<!--Online content box render-->
@if (itemIndex === -1 && fullRecord?.onlineContents) {
  @if (
    fullRecord?.targetType === 'AG' ||
    fullRecord?.targetType === 'AV' ||
    fullRecord?.targetType === 'ZZ'
  ) {
    <div class="online-content" fxLayout="column">
      <h6 class="text-center">{{ fullRecord?.onlineContents.title }}</h6>
      @for (item of fullRecord?.onlineContents.items; track item) {
        @if (item?.href) {
          <div fxLayout="row">
            <div fxFlex="166px">
              <a
                target="_blank"
                [href]="item.href"
                [matTooltip]="item.title?.length ? item.title : item.href"
              >
                <div class="ellipsis">
                  {{ item.title?.length ? item.title : (item.href | truncateUrl) }}
                </div>
              </a>
            </div>
            <div>
              <a target="_blank" [href]="item.href" [matTooltip]="item.href"
                ><mat-icon class="mat-icon-xs">launch</mat-icon></a
              >
            </div>
          </div>
        }
      }
    </div>
  }
}
